<template>
  <div class="flex flex-col h-full">

    <!-- Header -->
    <div class="flex items-center justify-between px-6 py-4 border-b border-slate-100 dark:border-slate-800 flex-shrink-0">
      <div>
        <h2 class="text-lg font-semibold text-slate-800 dark:text-slate-100">Campanhas WhatsApp API Oficial</h2>
        <p class="text-sm text-slate-500 dark:text-slate-400">Disparo via API Oficial Meta (Cloud) com templates aprovados</p>
      </div>
      <button
        class="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-emerald-600 rounded-lg hover:bg-emerald-700 transition-colors disabled:opacity-50"
        :disabled="!cloudInboxes.length"
        @click="openCreate"
      >
        <span class="text-lg leading-none">+</span> Nova campanha
      </button>
    </div>

    <!-- Sem inboxes cloud -->
    <div v-if="!loading && !cloudInboxes.length" class="flex flex-col items-center justify-center flex-1 gap-3 text-slate-400">
      <span class="text-5xl">📭</span>
      <p class="font-medium">Nenhum canal WhatsApp Cloud (API Oficial) configurado</p>
      <p class="text-sm">Configure um canal WhatsApp Cloud em Configurações → Canais</p>
    </div>

    <!-- Loading -->
    <div v-else-if="loading" class="flex items-center justify-center flex-1 gap-2.5 text-slate-400 text-sm">
      <span class="w-4 h-4 border-2 border-slate-200 border-t-emerald-500 rounded-full animate-spin"></span>
      Carregando campanhas...
    </div>

    <!-- Empty -->
    <div v-else-if="!campaigns.length" class="flex flex-col items-center justify-center flex-1 gap-3 text-slate-400 py-16">
      <span class="text-5xl">📣</span>
      <p class="font-medium">Nenhuma campanha criada</p>
      <p class="text-sm">Clique em "+ Nova campanha" para começar</p>
    </div>

    <!-- TABLE -->
    <div v-else class="flex-1 overflow-y-auto">
      <table class="w-full border-collapse">
        <thead class="sticky top-0 z-10">
          <tr class="bg-slate-50 dark:bg-slate-800/80 border-b border-slate-200 dark:border-slate-700">
            <th class="text-left px-6 py-3 text-xs font-semibold text-slate-400 uppercase tracking-wider">Campanha</th>
            <th class="text-left px-4 py-3 text-xs font-semibold text-slate-400 uppercase tracking-wider w-72">Progresso</th>
            <th class="text-left px-4 py-3 text-xs font-semibold text-slate-400 uppercase tracking-wider w-36">Status</th>
            <th class="px-4 py-3 w-24"></th>
          </tr>
        </thead>
        <tbody class="divide-y divide-slate-100 dark:divide-slate-800">
          <tr v-for="c in campaigns" :key="c.id" class="hover:bg-slate-50 dark:hover:bg-slate-800/40 transition-colors group">
            <td class="px-6 py-4">
              <div class="flex items-center gap-3">
                <div class="w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0 text-sm bg-emerald-100 dark:bg-emerald-900/30">📣</div>
                <div class="min-w-0">
                  <button class="font-semibold text-slate-800 dark:text-slate-100 hover:text-emerald-600 text-sm text-left block max-w-xs truncate transition-colors" @click="openDetail(c)">{{ c.title }}</button>
                  <div class="text-xs text-slate-400 mt-0.5 truncate">{{ c.inbox_name }} · {{ c.template_name }}</div>
                </div>
              </div>
            </td>
            <td class="px-4 py-4">
              <div class="flex items-center gap-2">
                <div class="flex-1 bg-slate-100 dark:bg-slate-700 rounded-full h-1.5 overflow-hidden">
                  <div class="h-1.5 rounded-full transition-all duration-700" :class="progressBarColor(c)" :style="{ width: (c.stats.progress || 0) + '%' }"></div>
                </div>
                <span class="text-xs font-semibold text-slate-500 dark:text-slate-400 flex-shrink-0 w-9 text-right">{{ c.stats.progress || 0 }}%</span>
              </div>
              <div class="flex items-center gap-3 mt-1.5 text-xs text-slate-400">
                <span>{{ sentCount(c) }}/{{ c.stats.total }} enviados</span>
                <span v-if="c.stats.failed > 0" class="text-red-500 font-medium">{{ c.stats.failed }} falhas</span>
              </div>
            </td>
            <td class="px-4 py-4">
              <span :class="statusBadgeClass(c)" class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold whitespace-nowrap">
                <span v-if="c.status === 'running'" class="w-2.5 h-2.5 border-2 border-current border-t-transparent rounded-full animate-spin flex-shrink-0"></span>
                {{ statusLabel(c) }}
              </span>
            </td>
            <td class="px-4 py-4">
              <div class="flex items-center gap-1 justify-end">
                <button class="w-7 h-7 flex items-center justify-center rounded-full text-slate-400 hover:text-emerald-600 hover:bg-emerald-50 dark:hover:bg-emerald-900/30 transition-colors text-sm opacity-0 group-hover:opacity-100" title="Detalhes" @click="openDetail(c)">👁</button>
                <button v-if="canTrigger(c)" class="w-7 h-7 flex items-center justify-center rounded-full text-slate-400 hover:text-emerald-600 hover:bg-emerald-50 dark:hover:bg-emerald-900/30 transition-colors text-sm opacity-0 group-hover:opacity-100" title="Disparar" :disabled="acting === c.id" @click="quickAction(c, 'trigger')">▶️</button>
                <button v-if="c.status === 'running'" class="w-7 h-7 flex items-center justify-center rounded-full text-slate-400 hover:text-amber-600 hover:bg-amber-50 dark:hover:bg-amber-900/30 transition-colors text-sm opacity-0 group-hover:opacity-100" title="Pausar" :disabled="acting === c.id" @click="quickAction(c, 'pause')">⏸</button>
                <button v-if="c.status === 'paused'" class="w-7 h-7 flex items-center justify-center rounded-full text-slate-400 hover:text-emerald-600 hover:bg-emerald-50 dark:hover:bg-emerald-900/30 transition-colors text-sm opacity-0 group-hover:opacity-100" title="Retomar" :disabled="acting === c.id" @click="quickAction(c, 'resume')">▶️</button>
                <button class="w-7 h-7 flex items-center justify-center rounded-full text-slate-300 hover:text-red-500 hover:bg-red-50 dark:hover:bg-red-900/20 transition-colors text-sm opacity-0 group-hover:opacity-100" title="Excluir" @click="deleteTarget = c">🗑️</button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- ===== MODAL CRIAR (3 passos) ===== -->
    <div v-if="showCreate" class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm p-4">
      <div class="bg-white dark:bg-slate-900 rounded-2xl shadow-2xl w-full max-w-2xl max-h-[92vh] flex flex-col">
        <div class="flex items-center justify-between px-6 py-4 border-b border-slate-100 dark:border-slate-800 flex-shrink-0">
          <div class="flex items-center gap-3">
            <h3 class="text-base font-semibold text-slate-800 dark:text-slate-100">Nova campanha API Oficial</h3>
            <div class="flex items-center gap-1.5">
              <span v-for="s in 3" :key="s" class="w-6 h-1.5 rounded-full" :class="step >= s ? 'bg-emerald-500' : 'bg-slate-200 dark:bg-slate-700'"></span>
            </div>
          </div>
          <button class="text-slate-400 hover:text-slate-600 text-xl leading-none" @click="closeCreate">✕</button>
        </div>

        <div class="overflow-y-auto flex-1 px-6 py-5 space-y-5">

          <!-- PASSO 1: Inbox + Template -->
          <template v-if="step === 1">
            <div>
              <label class="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">Canal WhatsApp Cloud *</label>
              <div class="relative">
                <select v-model="form.inbox_id" style="-webkit-appearance: none; -moz-appearance: none; appearance: none; background-image: none;" class="w-full border border-slate-200 dark:border-slate-700 rounded-lg px-3 py-2 pr-8 text-sm bg-white dark:bg-slate-800 text-slate-800 dark:text-slate-100" @change="form.template = null">
                  <option :value="null" disabled>Selecione um canal</option>
                  <option v-for="ib in cloudInboxes" :key="ib.id" :value="ib.id">{{ ib.name }}</option>
                </select>
                <span class="text-slate-300 text-xs absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none">▾</span>
              </div>
            </div>
            <div v-if="form.inbox_id">
              <label class="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">Template aprovado *</label>
              <div class="relative" ref="templateComboRef">
                <button type="button" class="w-full text-left border border-slate-200 dark:border-slate-700 rounded-lg px-3 py-2 text-sm bg-white dark:bg-slate-800 text-slate-800 dark:text-slate-100 focus:outline-none focus:ring-2 focus:ring-emerald-300 flex items-center justify-between gap-2" @click="toggleCombo">
                  <span v-if="form.template" class="truncate">{{ form.template.name }} <span class="text-slate-400">({{ form.template.language }} · {{ form.template.category }})</span></span>
                  <span v-else class="text-slate-400">Selecione um template</span>
                  <span class="text-slate-300 text-xs transition-transform flex-shrink-0" :class="isComboOpen ? 'rotate-180' : ''">▾</span>
                </button>
                <Teleport to="body">
                  <div v-if="isComboOpen" ref="comboDropdownRef" class="bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg shadow-xl overflow-hidden" :style="{ position: 'fixed', top: comboPosition.top, bottom: comboPosition.bottom, left: comboPosition.left, width: comboPosition.width, zIndex: 9999 }">
                    <input ref="templateSearchInputRef" v-model="templateSearch" type="text" placeholder="Buscar template pelo nome..." class="w-full text-sm border-b border-slate-200 dark:border-slate-700 px-3 py-2 bg-white dark:bg-slate-800 text-slate-800 dark:text-slate-100 focus:outline-none" @keydown.esc="closeCombo" />
                    <div class="max-h-64 overflow-y-auto">
                      <button v-for="t in filteredTemplates" :key="t.name + t.language" type="button" class="w-full text-left px-3 py-1.5 text-sm border-b border-slate-100 dark:border-slate-700 last:border-0 hover:bg-emerald-50 dark:hover:bg-slate-700 text-slate-800 dark:text-slate-100" :class="form.template && form.template.name === t.name && form.template.language === t.language ? 'bg-emerald-50 dark:bg-slate-700 font-medium' : ''" @click="selectTemplate(t)">{{ t.name }} <span class="text-xs text-slate-400">({{ t.language }} · {{ t.category }})</span></button>
                      <div v-if="approvedTemplates.length && !filteredTemplates.length" class="px-3 py-3 text-xs text-amber-600">Nenhum template casa com a busca</div>
                      <div v-if="!approvedTemplates.length" class="px-3 py-3 text-xs text-amber-500">Nenhum template APPROVED neste canal. Aprove um na Meta primeiro.</div>
                    </div>
                  </div>
                </Teleport>
              </div>
            </div>
            <div v-if="form.template" class="rounded-xl border border-slate-100 dark:border-slate-800 p-3 bg-slate-50 dark:bg-slate-800/50">
              <p class="text-xs font-semibold text-slate-400 uppercase mb-1">Preview do corpo</p>
              <p class="text-sm text-slate-700 dark:text-slate-200 whitespace-pre-line" v-html="highlightedBody"></p>
              <p v-if="templateVars.length" class="text-xs text-slate-400 mt-2">{{ templateVars.length }} variável(is): {{ varListLabel }}</p>
            </div>
          </template>

          <!-- PASSO 2: Audience + variaveis -->
          <template v-if="step === 2">
            <div class="flex gap-2">
              <button :class="sourceBtn('csv')" @click="form.source_type = 'csv'">📂 Upload CSV</button>
              <button :class="sourceBtn('contacts_filter')" @click="form.source_type = 'contacts_filter'">👥 Filtro de Contatos</button>
            </div>

            <!-- CSV -->
            <div v-if="form.source_type === 'csv'">
              <div class="border-2 border-dashed rounded-xl p-6 text-center cursor-pointer transition-colors"
                :class="form.csvFile ? 'border-emerald-400 bg-emerald-50 dark:bg-emerald-900/20' : 'border-slate-200 dark:border-slate-700 hover:border-emerald-300'"
                @click="$refs.csvInput.click()" @dragover.prevent @drop.prevent="onDrop">
                <input ref="csvInput" type="file" accept=".csv,.txt" class="hidden" @change="onFileChange" />
                <div v-if="!form.csvFile">
                  <p class="text-3xl mb-2">📂</p>
                  <p class="text-sm text-slate-500">Arraste o CSV ou <span class="text-emerald-600 font-medium">clique para selecionar</span></p>
                  <p class="text-xs text-slate-400 mt-1">Coluna "telefone" obrigatória. Outras colunas viram variáveis.</p>
                </div>
                <div v-else class="text-sm">
                  <p class="text-2xl mb-1">✅</p>
                  <p class="font-medium text-slate-700 dark:text-slate-200">{{ form.csvFile.name }}</p>
                  <p class="text-slate-500 text-xs mt-0.5">{{ form.csvCount != null ? form.csvCount + ' contatos · ' + form.csvHeaders.length + ' colunas' : 'Arquivo selecionado' }}</p>
                  <button class="text-xs text-red-400 hover:text-red-600 mt-2" @click.stop="clearCsv">Remover</button>
                </div>
              </div>
            </div>

            <!-- Contacts filter -->
            <div v-else class="space-y-3">
              <div>
                <label class="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">Etiquetas (qualquer uma)</label>
                <div class="flex flex-wrap gap-1.5">
                  <button v-for="lb in labels" :key="lb.id"
                    :class="['px-2.5 py-1 rounded-full text-xs font-medium border transition-colors', form.label_ids.includes(lb.id) ? 'bg-emerald-100 text-emerald-700 border-emerald-300 dark:bg-emerald-900/30 dark:text-emerald-300' : 'bg-white dark:bg-slate-800 text-slate-500 border-slate-200 dark:border-slate-700']"
                    @click="toggleLabel(lb.id)">{{ lb.title }}</button>
                  <span v-if="!labels.length" class="text-xs text-slate-400">Nenhuma etiqueta na conta</span>
                </div>
              </div>
              <div class="grid grid-cols-2 gap-3">
                <div>
                  <label class="block text-xs text-slate-500 mb-1">Criado depois de</label>
                  <input v-model="form.created_after" type="date" class="w-full border border-slate-200 dark:border-slate-700 rounded-lg px-3 py-2 text-sm bg-white dark:bg-slate-800 text-slate-800 dark:text-slate-100" />
                </div>
                <div>
                  <label class="block text-xs text-slate-500 mb-1">Criado antes de</label>
                  <input v-model="form.created_before" type="date" class="w-full border border-slate-200 dark:border-slate-700 rounded-lg px-3 py-2 text-sm bg-white dark:bg-slate-800 text-slate-800 dark:text-slate-100" />
                </div>
              </div>
              <p class="text-xs text-slate-400">Os leads serão montados a partir dos contatos que baterem com o filtro no momento da criação.</p>
            </div>

            <!-- Mapeamento de variaveis -->
            <div v-if="templateVars.length">
              <label class="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-2">Mapeamento de variáveis do template</label>
              <div class="space-y-2">
                <div v-for="v in templateVars" :key="v" class="flex items-center gap-2">
                  <code class="text-xs bg-slate-100 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 px-1.5 py-1 rounded font-mono text-slate-600 dark:text-slate-300 w-12 text-center">{{ vlabel(v) }}</code>
                  <span class="text-slate-300">←</span>
                  <select v-model="form.varConfig[v]" class="flex-1 border border-slate-200 dark:border-slate-700 rounded-lg px-3 py-2 text-sm bg-white dark:bg-slate-800 text-slate-800 dark:text-slate-100">
                    <option value="">— escolher fonte —</option>
                    <template v-if="form.source_type === 'csv'">
                      <option v-for="(h, idx) in form.csvHeaders" :key="idx" :value="'col:' + (idx + 1)">Coluna {{ idx + 1 }} — {{ h }}</option>
                    </template>
                    <template v-else>
                      <option value="contact.name">Nome do contato</option>
                      <option value="contact.phone_number">Telefone</option>
                      <option value="contact.email">E-mail</option>
                    </template>
                  </select>
                </div>
              </div>
            </div>
          </template>

          <!-- PASSO 3: Confirmar -->
          <template v-if="step === 3">
            <div>
              <label class="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">Nome da campanha *</label>
              <input v-model="form.title" type="text" placeholder="Ex: Remarketing GOV-RJ abril" class="w-full border border-slate-200 dark:border-slate-700 rounded-lg px-3 py-2 text-sm bg-white dark:bg-slate-800 text-slate-800 dark:text-slate-100" />
            </div>
            <div>
              <label class="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">Descrição <span class="font-normal text-slate-400">— opcional</span></label>
              <input v-model="form.description" type="text" class="w-full border border-slate-200 dark:border-slate-700 rounded-lg px-3 py-2 text-sm bg-white dark:bg-slate-800 text-slate-800 dark:text-slate-100" />
            </div>

            <!-- Pacing -->
            <div>
              <label class="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-2">Velocidade de envio</label>
              <div class="grid grid-cols-4 gap-2 mb-3">
                <button v-for="p in pacingPresets" :key="p.key"
                  :class="['flex flex-col items-center gap-1 p-3 rounded-xl border-2 text-xs transition-all', form.pacing_preset === p.key ? 'border-emerald-500 bg-emerald-50 dark:bg-emerald-900/30 text-emerald-700 dark:text-emerald-300' : 'border-slate-200 dark:border-slate-700 text-slate-500 hover:border-emerald-300']"
                  @click="selectPacing(p)">
                  <span class="text-xl">{{ p.icon }}</span>
                  <span class="font-semibold">{{ p.label }}</span>
                </button>
              </div>
              <div v-if="form.pacing_preset === 'custom'" class="grid grid-cols-3 gap-3 p-4 bg-slate-50 dark:bg-slate-800 rounded-xl">
                <div>
                  <label class="block text-xs text-slate-500 mb-1">Intervalo (seg)</label>
                  <input v-model.number="form.send_interval_seconds" type="number" min="1" class="w-full border border-slate-200 dark:border-slate-600 rounded-lg px-3 py-2 text-sm bg-white dark:bg-slate-900 text-slate-800 dark:text-slate-100" />
                </div>
                <div>
                  <label class="block text-xs text-slate-500 mb-1">Lote (msgs)</label>
                  <input v-model.number="form.batch_size" type="number" min="1" class="w-full border border-slate-200 dark:border-slate-600 rounded-lg px-3 py-2 text-sm bg-white dark:bg-slate-900 text-slate-800 dark:text-slate-100" />
                </div>
                <div>
                  <label class="block text-xs text-slate-500 mb-1">Pausa lote (seg)</label>
                  <input v-model.number="form.batch_interval_seconds" type="number" min="0" class="w-full border border-slate-200 dark:border-slate-600 rounded-lg px-3 py-2 text-sm bg-white dark:bg-slate-900 text-slate-800 dark:text-slate-100" />
                </div>
              </div>
              <p v-if="durationEstimate" class="text-xs text-slate-500 mt-2">⏱ Duração estimada: {{ durationEstimate }}</p>
            </div>

            <!-- Resumo -->
            <div class="rounded-xl border border-slate-100 dark:border-slate-800 p-3 text-sm space-y-1.5">
              <div class="flex justify-between"><span class="text-slate-400">Canal</span><span class="font-medium text-slate-700 dark:text-slate-200">{{ inboxName(form.inbox_id) }}</span></div>
              <div class="flex justify-between"><span class="text-slate-400">Template</span><span class="font-medium text-slate-700 dark:text-slate-200 font-mono">{{ form.template?.name }}</span></div>
              <div class="flex justify-between"><span class="text-slate-400">Fonte</span><span class="font-medium text-slate-700 dark:text-slate-200">{{ form.source_type === 'csv' ? (form.csvCount + ' do CSV') : 'Filtro de contatos' }}</span></div>
            </div>
          </template>

        </div>

        <!-- Footer -->
        <div class="flex items-center justify-between px-6 py-4 border-t border-slate-100 dark:border-slate-800 flex-shrink-0">
          <p v-if="createError" class="text-sm text-red-500 max-w-xs truncate">{{ createError }}</p>
          <button v-else-if="step > 1" class="px-4 py-2 text-sm border border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-300 rounded-lg hover:bg-slate-50 dark:hover:bg-slate-800" @click="step--">‹ Voltar</button>
          <div v-else />
          <div class="flex gap-3">
            <button class="px-4 py-2 text-sm border border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-300 rounded-lg hover:bg-slate-50 dark:hover:bg-slate-800" @click="closeCreate">Cancelar</button>
            <button v-if="step < 3" class="px-5 py-2 text-sm font-medium text-white bg-emerald-600 rounded-lg hover:bg-emerald-700 disabled:opacity-50" :disabled="!canNext" @click="step++">Próximo ›</button>
            <template v-else>
              <button class="px-4 py-2 text-sm font-medium text-emerald-700 bg-emerald-100 dark:bg-emerald-900/30 dark:text-emerald-300 rounded-lg hover:bg-emerald-200 disabled:opacity-50" :disabled="creating || !form.title" @click="submit(false)">Salvar rascunho</button>
              <button class="px-5 py-2 text-sm font-medium text-white bg-emerald-600 rounded-lg hover:bg-emerald-700 disabled:opacity-50" :disabled="creating || !form.title" @click="submit(true)">{{ creating ? 'Criando...' : 'Criar e disparar' }}</button>
            </template>
          </div>
        </div>
      </div>
    </div>

    <!-- DELETE -->
    <div v-if="deleteTarget" class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
      <div class="bg-white dark:bg-slate-900 rounded-2xl shadow-2xl p-6 w-96 text-center">
        <p class="text-4xl mb-3">🗑️</p>
        <h3 class="text-base font-semibold text-slate-800 dark:text-slate-100 mb-2">Excluir campanha?</h3>
        <p class="text-sm text-slate-500 mb-5">"<strong>{{ deleteTarget.title }}</strong>" e todos os seus leads serão removidos.</p>
        <div class="flex gap-3 justify-center">
          <button class="px-4 py-2 text-sm border border-slate-200 dark:border-slate-700 rounded-lg text-slate-600 dark:text-slate-400" @click="deleteTarget = null">Cancelar</button>
          <button class="px-4 py-2 text-sm font-medium bg-red-500 text-white rounded-lg hover:bg-red-600 disabled:opacity-50" :disabled="deleting" @click="doDelete">{{ deleting ? 'Excluindo...' : 'Sim, excluir' }}</button>
        </div>
      </div>
    </div>

    <!-- DETAIL -->
    <BmtWhatsappOfficialCampaignDetail v-if="selectedCampaign" :campaign="selectedCampaign" @close="selectedCampaign = null" @refresh="loadCampaigns" />

  </div>
</template>

<script>
import { ref, reactive, computed, nextTick, onMounted, onUnmounted } from 'vue';
import { useStore } from 'dashboard/composables/store';
import { emitter } from 'shared/helpers/mitt';
import CampaignsApi from '../../../../api/bmtWhatsappOfficialCampaigns';
import BmtWhatsappOfficialCampaignDetail from './BmtWhatsappOfficialCampaign/BmtWhatsappOfficialCampaignDetail.vue';

const PACING_PRESETS = [
  { key: 'slow', label: 'Lento', icon: '🐢', send_interval_seconds: 60, batch_size: 30, batch_interval_seconds: 1800 },
  { key: 'moderate', label: 'Moderado', icon: '🚚', send_interval_seconds: 20, batch_size: 100, batch_interval_seconds: 900 },
  { key: 'fast', label: 'Rápido', icon: '⚡', send_interval_seconds: 8, batch_size: 200, batch_interval_seconds: 600 },
  { key: 'custom', label: 'Custom', icon: '⚙️', send_interval_seconds: 20, batch_size: 100, batch_interval_seconds: 900 },
];

export default {
  name: 'BmtWhatsappOfficialCampaignsPage',
  components: { BmtWhatsappOfficialCampaignDetail },
  setup() {
    const store = useStore();
    const campaigns = ref([]);
    const loading = ref(true);
    const showCreate = ref(false);
    const step = ref(1);
    const creating = ref(false);
    const createError = ref('');
    const selectedCampaign = ref(null);
    const deleteTarget = ref(null);
    const deleting = ref(false);
    const acting = ref(null);
    let pollTimer = null;

    const defaultForm = () => ({
      inbox_id: null, template: null, source_type: 'csv',
      csvFile: null, csvHeaders: [], csvCount: null,
      varConfig: {}, label_ids: [], created_after: '', created_before: '',
      title: '', description: '',
      pacing_preset: 'moderate', send_interval_seconds: 20, batch_size: 100, batch_interval_seconds: 900,
    });
    const form = reactive(defaultForm());
    const pacingPresets = PACING_PRESETS;

    const cloudInboxes = computed(() => {
      const list = store.getters['inboxes/getWhatsAppInboxes'] || [];
      return list.filter(i => !i.provider || i.provider === 'whatsapp_cloud');
    });
    const labels = computed(() => store.getters['labels/getLabels'] || []);

    const approvedTemplates = computed(() => {
      if (!form.inbox_id) return [];
      const tpls = store.getters['inboxes/getWhatsAppTemplates'](form.inbox_id) || [];
      return tpls.filter(t => (t.status || '').toUpperCase() === 'APPROVED');
    });
    const templateSearch = ref('');
    const isComboOpen = ref(false);
    const templateComboRef = ref(null);
    const templateSearchInputRef = ref(null);
    const comboDropdownRef = ref(null);
    const comboPosition = ref({ top: '0px', left: '0px', width: '0px', bottom: 'auto' });
    const updateComboPosition = () => {
      if (!templateComboRef.value) return;
      const r = templateComboRef.value.getBoundingClientRect();
      const dropdownEstimate = 320;
      const spaceBelow = window.innerHeight - r.bottom - 16;
      const spaceAbove = r.top - 16;
      if (spaceBelow >= dropdownEstimate || spaceBelow >= spaceAbove) {
        comboPosition.value = { top: `${r.bottom + 4}px`, bottom: 'auto', left: `${r.left}px`, width: `${r.width}px` };
      } else {
        comboPosition.value = { top: 'auto', bottom: `${window.innerHeight - r.top + 4}px`, left: `${r.left}px`, width: `${r.width}px` };
      }
    };
    const toggleCombo = () => {
      isComboOpen.value = !isComboOpen.value;
      if (isComboOpen.value) {
        updateComboPosition();
        nextTick(() => templateSearchInputRef.value?.focus());
      }
    };
    const closeCombo = () => { isComboOpen.value = false; templateSearch.value = ''; };
    const selectTemplate = t => { form.template = t; form.varConfig = {}; closeCombo(); };
    const onDocClick = e => {
      if (!isComboOpen.value) return;
      const inBtn = templateComboRef.value && templateComboRef.value.contains(e.target);
      const inDrop = comboDropdownRef.value && comboDropdownRef.value.contains(e.target);
      if (!inBtn && !inDrop) closeCombo();
    };
    const onWindowChange = () => { if (isComboOpen.value) updateComboPosition(); };
    onMounted(() => {
      document.addEventListener('mousedown', onDocClick);
      window.addEventListener('resize', onWindowChange);
      window.addEventListener('scroll', onWindowChange, true);
    });
    onUnmounted(() => {
      document.removeEventListener('mousedown', onDocClick);
      window.removeEventListener('resize', onWindowChange);
      window.removeEventListener('scroll', onWindowChange, true);
    });
    const filteredTemplates = computed(() => {
      const q = templateSearch.value.toLowerCase().trim();
      if (!q) return approvedTemplates.value;
      return approvedTemplates.value.filter(t =>
        (t.name || '').toLowerCase().includes(q) || (t.category || '').toLowerCase().includes(q)
      );
    });

    const bodyText = computed(() => {
      const comps = form.template?.components || [];
      const body = comps.find(c => c.type === 'BODY');
      return body?.text || '';
    });
    const templateVars = computed(() => {
      // Sprint TEMPLATE-NAMED-VARS: captura NUMBERED ({{1}}) OU NAMED ({{customer_name}}, Meta v22+).
      const found = [...bodyText.value.matchAll(/\{\{(\d+|[a-zA-Z_][a-zA-Z0-9_]*)\}\}/g)].map(m => m[1]);
      const uniq = [...new Set(found)];
      // numeradas ordenam numericamente; nomeadas mantem ordem de aparicao (Meta usa parameter_name).
      return uniq.sort((a, b) => {
        const an = /^\d+$/.test(a), bn = /^\d+$/.test(b);
        if (an && bn) return Number(a) - Number(b);
        if (an) return -1;
        if (bn) return 1;
        return 0;
      });
    });
    const highlightedBody = computed(() =>
      // Sprint TEMPLATE-NAMED-VARS: destaca numeradas e nomeadas.
      bodyText.value.replace(/\{\{(\d+|[a-zA-Z_][a-zA-Z0-9_]*)\}\}/g, '<span class="text-emerald-600 font-semibold bg-emerald-50 dark:bg-emerald-900/30 px-1 rounded">{{$1}}</span>')
    );
    const vlabel = v => `{{${v}}}`;
    const varListLabel = computed(() => templateVars.value.map(vlabel).join(', '));

    const canNext = computed(() => {
      if (step.value === 1) return !!form.inbox_id && !!form.template;
      if (step.value === 2) {
        const hasSource = form.source_type === 'csv' ? !!form.csvFile : (form.label_ids.length || form.created_after || form.created_before);
        const varsOk = templateVars.value.every(v => !!form.varConfig[v]);
        return hasSource && varsOk;
      }
      return true;
    });

    const durationEstimate = computed(() => {
      const total = form.source_type === 'csv' ? form.csvCount : null;
      if (!total || total <= 0) return null;
      const i = form.send_interval_seconds || 20, b = form.batch_size || 0, p = form.batch_interval_seconds || 0;
      let sec = b > 0 && p > 0 ? ((Math.ceil(total / b) - 1) * p) + ((total - 1) * i) : (total - 1) * i;
      if (sec < 60) return `~${sec} segundos`;
      if (sec < 3600) return `~${Math.round(sec / 60)} minutos`;
      const h = Math.floor(sec / 3600), m = Math.round((sec % 3600) / 60);
      return `~${h}h${m > 0 ? ` ${m}min` : ''}`;
    });

    // status helpers
    const sentCount = c => (c.stats.sent || 0) + (c.stats.delivered || 0) + (c.stats.read || 0) + (c.stats.replied || 0);
    const statusLabel = c => ({ draft: 'Rascunho', scheduled: 'Agendada', running: 'Disparando', paused: 'Pausada', completed: c.stats.failed > 0 ? 'Concluída c/ falhas' : 'Concluída', cancelled: 'Cancelada', failed: 'Falhou' }[c.status] || c.status);
    const statusBadgeClass = c => ({
      running: 'bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-400',
      paused: 'bg-yellow-100 text-yellow-700 dark:bg-yellow-900/30 dark:text-yellow-400',
      completed: 'bg-woot-100 text-woot-700 dark:bg-woot-900/30 dark:text-woot-400',
      failed: 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400',
      scheduled: 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400',
    }[c.status] || 'bg-slate-100 text-slate-600 dark:bg-slate-700 dark:text-slate-300');
    const progressBarColor = c => ({ running: 'bg-purple-500', paused: 'bg-yellow-400', completed: 'bg-woot-500', failed: 'bg-red-400' }[c.status] || 'bg-emerald-500');
    const canTrigger = c => ['draft', 'scheduled'].includes(c.status) && (c.stats.queued || 0) > 0;

    const sourceBtn = type => ['flex-1 px-3 py-2 rounded-lg text-sm font-medium border transition-colors', form.source_type === type ? 'bg-emerald-50 text-emerald-700 border-emerald-300 dark:bg-emerald-900/30 dark:text-emerald-300' : 'bg-white dark:bg-slate-800 text-slate-500 border-slate-200 dark:border-slate-700'];

    function inboxName(id) { const ib = cloudInboxes.value.find(i => i.id === id); return ib ? ib.name : id; }
    function selectPacing(p) {
      form.pacing_preset = p.key;
      form.send_interval_seconds = p.send_interval_seconds;
      form.batch_size = p.batch_size;
      form.batch_interval_seconds = p.batch_interval_seconds;
    }
    function toggleLabel(id) {
      const i = form.label_ids.indexOf(id);
      if (i === -1) form.label_ids.push(id); else form.label_ids.splice(i, 1);
    }
    function onFileChange(e) { const f = e.target.files[0]; if (f) setFile(f); }
    function onDrop(e) { const f = e.dataTransfer.files[0]; if (f) setFile(f); }
    function setFile(file) {
      form.csvFile = file;
      const reader = new FileReader();
      reader.onload = ev => {
        const text = ev.target.result;
        const lines = text.split('\n').filter(l => l.trim());
        const first = lines[0] || '';
        const sep = (first.split(';').length > first.split(',').length) ? ';' : ',';
        form.csvHeaders = first.split(sep).map(h => h.trim().replace(/^["']|["']$/g, ''));
        form.csvCount = Math.max(0, lines.length - 1);
      };
      reader.readAsText(file);
    }
    function clearCsv() { form.csvFile = null; form.csvHeaders = []; form.csvCount = null; }

    async function loadCampaigns() {
      try { const { data } = await CampaignsApi.get(); campaigns.value = Array.isArray(data) ? data : []; }
      catch { campaigns.value = []; }
    }

    function openCreate() {
      Object.assign(form, defaultForm());
      step.value = 1; createError.value = ''; showCreate.value = true;
    }
    function closeCreate() { showCreate.value = false; }
    function openDetail(c) { selectedCampaign.value = c; }

    async function submit(dispatchNow) {
      if (!form.title) { createError.value = 'Informe o nome da campanha'; return; }
      creating.value = true; createError.value = '';
      try {
        const payload = {
          campaign: {
            title: form.title,
            description: form.description,
            inbox_id: form.inbox_id,
            template_name: form.template.name,
            template_language: form.template.language,
            template_category: form.template.category,
            template_variables_config: templateVars.value.reduce((acc, v) => { if (form.varConfig[v]) acc[v] = form.varConfig[v]; return acc; }, {}),
            template_components_snapshot: { components: form.template.components || [] },
            source_type: form.source_type,
            source_config: form.source_type === 'contacts_filter'
              ? { label_ids: form.label_ids, created_after: form.created_after || null, created_before: form.created_before || null }
              : {},
            pacing_preset: form.pacing_preset,
            ...(form.pacing_preset === 'custom' ? {
              send_interval_seconds: form.send_interval_seconds,
              batch_size: form.batch_size,
              batch_interval_seconds: form.batch_interval_seconds,
            } : {}),
          },
        };
        const { data: campaign } = await CampaignsApi.create(payload);
        if (form.source_type === 'csv' && form.csvFile) {
          await CampaignsApi.uploadCsv(campaign.id, form.csvFile);
        }
        if (dispatchNow) {
          await CampaignsApi.trigger(campaign.id);
        }
        closeCreate();
        await loadCampaigns();
      } catch (err) {
        createError.value = err?.response?.data?.error || 'Erro ao criar campanha.';
      } finally {
        creating.value = false;
      }
    }

    async function quickAction(c, action) {
      acting.value = c.id;
      try { await CampaignsApi[action](c.id); await loadCampaigns(); }
      catch (err) { alert(err?.response?.data?.error || 'Erro na ação'); }
      finally { acting.value = null; }
    }

    async function doDelete() {
      if (!deleteTarget.value) return;
      deleting.value = true;
      try { await CampaignsApi.delete(deleteTarget.value.id); deleteTarget.value = null; await loadCampaigns(); }
      catch { alert('Erro ao excluir'); }
      finally { deleting.value = false; }
    }

    function onWsUpdate(data) {
      if (!data) return;
      const c = campaigns.value.find(x => x.id === data.id);
      if (!c) return;
      if (data.status) c.status = data.status;
      if (data.counts) {
        const total = data.counts.total || 0;
        const done = (data.counts.sent || 0) + (data.counts.delivered || 0) + (data.counts.read || 0) + (data.counts.replied || 0);
        c.stats = { ...c.stats, ...data.counts, progress: total ? Math.round((done / total) * 100) : 0 };
      }
    }

    onMounted(async () => {
      loading.value = true;
      store.dispatch('inboxes/get');
      store.dispatch('labels/get');
      await loadCampaigns();
      loading.value = false;
      emitter.on('BMT_WHATSAPP_CAMPAIGN_UPDATED', onWsUpdate);
      pollTimer = setInterval(() => {
        if (campaigns.value.some(c => ['running', 'scheduled'].includes(c.status))) loadCampaigns();
      }, 10000);
    });
    onUnmounted(() => {
      emitter.off('BMT_WHATSAPP_CAMPAIGN_UPDATED', onWsUpdate);
      if (pollTimer) clearInterval(pollTimer);
    });

    return {
      campaigns, loading, showCreate, step, creating, createError,
      selectedCampaign, deleteTarget, deleting, acting,
      form, pacingPresets, cloudInboxes, labels, approvedTemplates,
      filteredTemplates, templateSearch,
      isComboOpen, toggleCombo, closeCombo, selectTemplate, templateComboRef, templateSearchInputRef,
      comboPosition, comboDropdownRef,
      templateVars, highlightedBody, vlabel, varListLabel, canNext, durationEstimate,
      sentCount, statusLabel, statusBadgeClass, progressBarColor, canTrigger,
      sourceBtn, inboxName, selectPacing, toggleLabel,
      onFileChange, onDrop, clearCsv,
      loadCampaigns, openCreate, closeCreate, openDetail, submit, quickAction, doDelete,
    };
  },
};
</script>
